import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalCreateWork extends React.Component {

  constructor(props) {
    super(props);
    this.state = {role:"", company:"", company_url:"", start_month:"", end_month:"", location:"", description:"", status:""};
  }

  render() {
    if(this.props.shouldShow) {
      const submit_disabled = this.state.role.trim() === "";

      return (
        <ModalWrapper switchState={this.props.close} mainClass="create-poll">
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div><input type="text" value={this.state.role} onChange={(e) => handleChange(this, "role", e)} maxLength="100" placeholder="Role *" autoFocus /></div>
            <div><input type="text" value={this.state.company} onChange={(e) => handleChange(this, "company", e)} maxLength="100" placeholder="Company" /></div>
            <div><input type="text" value={this.state.company_url} onChange={(e) => handleChange(this, "company_url", e)} maxLength="100" placeholder="Company URL" /></div>
            <div><label>Start Month</label><input type="date" value={this.state.start_month} onChange={(e) => handleChange(this, "start_month", e)} maxLength="100" placeholder="Start Month" /></div>
            <div><label>End Month</label><input type="date" value={this.state.end_month} onChange={(e) => handleChange(this, "end_month", e)} maxLength="100" placeholder="End Month" /></div>
            <div><input type="text" value={this.state.location} onChange={(e) => handleChange(this, "location", e)} maxLength="100" placeholder="Location / City / Country" /></div>
            <div><textarea value={this.state.description} onChange={(e) => handleChange(this, "description", e)} maxLength="500" placeholder="Description" rows="5"></textarea></div>
            <div>Status: <select value={this.state.status} onChange={(e) => handleChange(this, "status", e)}>
              <option key={"o0"} value="0">No status</option>
              <option key={"o1"} value="1">9-to-5</option>
              <option key={"o2"} value="2">Freelance</option>
              <option key={"o3"} value="3">Ideation</option>
              <option key={"o4"} value="4">Building</option>
              <option key={"o5"} value="5">Launched</option>
              <option key={"o6"} value="6">Growing</option>
              <option key={"o7"} value="7">Revenue</option>
              <option key={"o8"} value="8">Automated</option>
              <option key={"o9"} value="9">Acquired</option>
              <option key={"o10"} value="10">Quit</option>
            </select></div>
            <div><input type="submit" value="Create" disabled={submit_disabled} /></div>
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  submitForm() {
    const {role, company, company_url, start_month, end_month, location, description, status} = this.state;
    const submit_disabled = role.trim() === "";
    if(!submit_disabled) {
      let Crole = role.replace(/'/g, "''");
      let Ccompany = company.replace(/'/g, "''");
      let Ccompany_url = company_url.replace(/'/g, "''");
      let Cstart_month = start_month.replace(/'/g, "''");
      let Cend_month = end_month.replace(/'/g, "''");
      let Clocation = location.replace(/'/g, "''");
      let Cdescription = description.replace(/'/g, "''");
      let Cstatus = status.replace(/'/g, "''");
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/work-create", JSON.stringify({session_token:this.props.session_token, role:Crole, company:Ccompany, company_url:Ccompany_url, start_month:Cstart_month, end_month:Cend_month, location:Clocation, description:Cdescription, status:Cstatus}), null, true, false, false, false, false, null, "work-index");
      this.props.close();
      this.setState({role:"", company:"", company_url:"", start_month:"", end_month:"", location:"", description:"", status:""});
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateWork)



// WEBPACK FOOTER //
// ./src/containers/ModalCreateWork.js